import { useEffect, useState, useMemo } from "react";
import { useLazyGetAvailableQtyListQuery } from "Services/ProductApiSlice";

export const useBulkStock = (itemIds: string[], skip: boolean = false) => {
  const [availableQtyMap, setAvailableQtyMap] = useState<Record<string, number>>({});
  const [triggerGetAvailableQtyList] = useLazyGetAvailableQtyListQuery();

  const memoizedItemIds = useMemo(() => itemIds.join(','), [itemIds]);

  useEffect(() => {
    if (skip || !itemIds.length) {
        setAvailableQtyMap({});
        return;
    }

    const fetchStock = () => {
      triggerGetAvailableQtyList({ items: itemIds, origin: window.location.origin }, false).then((result) => {
        const map: Record<string, number> = {};
        (result.data?.results ?? []).forEach(({ item, qty }: { item: string; qty: number }) => {
          map[item] = qty;
        });
        setAvailableQtyMap(map);
      });
    };

    fetchStock();
    const interval = setInterval(fetchStock, 30000);
    return () => clearInterval(interval);
  }, [memoizedItemIds, triggerGetAvailableQtyList, skip]);

  return availableQtyMap;
};
